export default "/images/5e37be3a5cdaff1cddec669b104430d0.png";